import { makeAutoObservable } from 'mobx';

class PricingPlan {

  id = null;
  title = null;
  description = null;
  kind = null;
  period = 0;
  periodAmount = 0;
  unlockFeeAmount = 0;
  prettyPrice = null;
  maxActiveRides = 1;

  constructor({
    id,
    title,
    description,
    kind,
    period,
    period_amount,
    unlock_fee_amount,
    pretty_price,
    max_active_rides
  }) {
    this.id = id;
    this.title = title;
    this.description = description;
    this.kind = kind;
    this.period = period;
    this.periodAmount = period_amount;
    this.unlockFeeAmount = unlock_fee_amount;
    this.prettyPrice = pretty_price;
    this.maxActiveRides = max_active_rides;

    makeAutoObservable(this);
  }

}

export default PricingPlan;
